module.exports={
  "name": "cabin",
  "description": "Cabin is the best self-hosted JavaScript and Node.js logging service.",
  "version": "14.0.0",
  "author": "Titanism",
  "browser": {
    "./src/middleware": false,
    "./src/message": false,
    "./lib/middleware": false,
    "./lib/message": false
  },
  "bugs": {
    "url": "https://github.com/cabinjs/cabin/issues"
  },
  "contributors": [
    "Titanism"
  ],
  "dependencies": {
    "@ladjs/format-util": "^1.0.4",
    "ansi-colors": "^4.1.3",
    "clf-date": "^0.2.1",
    "format-specifiers": "^1.0.0",
    "iserror": "^0.0.2",
    "merge-options": "^3.0.4",
    "ms": "^2.1.3",
    "on-finished": "^2.4.1",
    "parse-err": "^1.0.0",
    "parse-request": "^6.0.3"
  },
  "devDependencies": {
    "@babel/cli": "^7.25.9",
    "@babel/core": "^7.26.0",
    "@babel/preset-env": "^7.26.0",
    "@commitlint/cli": "^19.6.0",
    "@commitlint/config-conventional": "^19.6.0",
    "ava": "^5.3.1",
    "axe": "^13.0.0",
    "babelify": "^10.0.0",
    "browserify": "^17.0.0",
    "cross-env": "^7.0.3",
    "eslint": "^8.49.0",
    "eslint-config-xo-lass": "^2.0.1",
    "eslint-plugin-compat": "^4.2.0",
    "eslint-plugin-node": "^11.1.0",
    "express": "^4.21.1",
    "express-request-id": "1",
    "fixpack": "^4.0.0",
    "husky": "^9.0.11",
    "jsdom": "15",
    "koa": "^2.15.3",
    "koa-better-request-id": "^1.2.0",
    "koa-better-response-time": "^1.2.0",
    "koa-router": "^12.0.1",
    "lint-staged": "^15.2.10",
    "lodash": "^4.17.21",
    "nyc": "^17.1.0",
    "remark-cli": "11.0.0",
    "remark-preset-github": "^4.0.4",
    "request-received": "^0.0.3",
    "response-time": "^2.3.3",
    "rimraf": "^5.0.7",
    "signale": "^1.4.0",
    "supertest": "^7.0.0",
    "tinyify": "3.0.0",
    "xo": "^0.56.0"
  },
  "engines": {
    "node": ">=18"
  },
  "files": [
    "lib",
    "dist"
  ],
  "homepage": "https://github.com/cabinjs/cabin",
  "jsdelivr": "dist/cabin.min.js",
  "keywords": [
    "airbrake",
    "analytics",
    "app",
    "boilerplate",
    "bugsnag",
    "bunyan",
    "cabin",
    "chalk",
    "color",
    "colored",
    "console",
    "dashboard",
    "express",
    "framework",
    "frontend",
    "gui",
    "hackable",
    "headers",
    "helper",
    "kit",
    "koa",
    "lad",
    "lass",
    "library",
    "log",
    "logging",
    "logging",
    "loggly",
    "logs",
    "middleware",
    "mongo",
    "mongodb",
    "morgan",
    "object",
    "passport",
    "passportjs",
    "postgres",
    "postgresql",
    "raven",
    "request",
    "sentry",
    "signale",
    "sql",
    "stack",
    "stack-trace",
    "timber",
    "tool",
    "trace",
    "tracekit",
    "transport",
    "user",
    "utility",
    "utility",
    "winston"
  ],
  "license": "MIT",
  "main": "lib/index.js",
  "peerDependencies": {
    "axe": ">= 10.0.0"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/cabinjs/cabin"
  },
  "scripts": {
    "ava": "cross-env NODE_ENV=test ava",
    "browserify": "browserify src/index.js -o dist/cabin.js -s Cabin -g [ babelify --configFile ./.dist.babelrc.json ]",
    "build": "npm run build:clean && npm run build:lib && npm run build:dist",
    "build:clean": "rimraf lib dist",
    "build:dist": "npm run browserify && npm run minify",
    "build:lib": "babel --config-file ./.lib.babelrc.json src --out-dir lib",
    "lint": "xo --fix && remark . -qfo && fixpack",
    "lint-build": "npm run lint-lib && npm run lint-dist",
    "lint-dist": "eslint --no-inline-config -c .dist.eslintrc.json dist",
    "lint-lib": "eslint --no-inline-config -c .lib.eslintrc.json lib",
    "minify": "cross-env NODE_ENV=production browserify src/index.js -o dist/cabin.min.js -s Cabin -g [ babelify --configFile ./.dist.babelrc.json ] -p tinyify",
    "nyc": "cross-env NODE_ENV=test nyc ava",
    "prepare": "husky install",
    "pretest": "npm run lint",
    "test": "npm run build && npm run lint-build && npm run nyc"
  },
  "unpkg": "dist/cabin.min.js"
}
